<div class="item-passenger"> 
  <div class="item-passenger-labels">
    <div class="item-passenger-labels-title">
      <label class="item-passenger-label-check">
        {{truncateTextUi(passanger.displayName,'20') | titlecase }}
      </label>
      <img *ngIf="hasInfant" class="am-image-child" src="./assets/images/Infant.svg" alt="infant" />
    </div>
    <div class="item-passenger-label-info" *ngIf="!loadingStatusPassenger">
      <img [alt]="(copyEstatus | translate)" [src]="getIconEstatus"
        class="TitleFormAlert-icon" />
      <span>{{copyEstatus | translate}}</span>
    </div>
  </div>
  <button class="item-passenger-button item-passenger-button--active" *ngIf="showEdit" (click)="onEdit()"
    type="button">
    <span>{{ (isVerPass ? 'modalVerPass.pssbutton' : 'passengerSelection.passengerButton.edit') | translate }}</span>
  </button>
  <app-am-loading [typeLoading]="'COMPONENT_LOADING'" *ngIf="loadingStatusPassenger"></app-am-loading>
</div>

